import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandProvider } from "@/contexts/BrandContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import GlobalBusyBar from "@/components/GlobalBusyBar";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Estimatif from "@/pages/Estimatif";
import Finance from "@/pages/Finance";
import Pilotage from "@/pages/Pilotage";
import Fournisseurs from "@/pages/Fournisseurs";
import Prestataires from "@/pages/Prestataires";
import Clients from "@/pages/Clients";
import Audit from "@/pages/Audit";
import Prestations from "@/pages/Prestations";
import Enseignes from "@/pages/Enseignes";
import FranchiseurDetail, { FranchiseursList } from "@/pages/Franchiseurs";
import Franchimob from "@/pages/Franchimob";
// import Partenaires from "@/pages/Partenaires";  // deprecated — merged into Clients
import Drive from "@/pages/Drive";
import Ideas from "@/pages/Ideas";
import Assistant from "@/pages/Assistant";
import PublicFranchiseurTracking from "@/pages/PublicFranchiseurTracking";
import SignDevis from "@/pages/SignDevis";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BrandProvider>
          <GlobalBusyBar />
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/public/franchiseur/:token" element={<PublicFranchiseurTracking />} />
            <Route path="/signer/:token" element={<SignDevis />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/projets" element={<Projects />} />
              <Route path="/projets/:id" element={<ProjectDetail />} />
              <Route path="/estimatif" element={<Estimatif />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/pilotage" element={<Pilotage />} />
              <Route path="/fournisseurs" element={<Fournisseurs />} />
              <Route path="/prestataires" element={<Prestataires />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/prestations" element={<Prestations />} />
              <Route path="/enseignes" element={<Enseignes />} />
              <Route path="/franchiseurs" element={<FranchiseursList />} />
              <Route path="/franchiseurs/:nom" element={<FranchiseurDetail />} />
              <Route path="/franchimob" element={<Franchimob />} />
              <Route path="/partenaires" element={<Navigate to="/clients" replace />} />
              <Route path="/drive" element={<Drive />} />
              <Route path="/ideas" element={<Ideas />} />
              <Route path="/assistant" element={<Assistant />} />
            </Route>
          </Routes>
        </BrandProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
